/**
 * Предустановленные вступительные фразы письма «Передать в производство».
 * Должны совпадать с server/src/constants/productionHandoffIntroPhrases.ts
 */
export const PRODUCTION_HANDOFF_INTRO_PHRASES = [
  'Для вас есть проект',
  'Направляю проект в производство',
  'Прошу взять проект в работу',
  'Передаю материалы по проекту',
  'Готово к запуску в производство',
] as const;

export type ProductionHandoffIntroPhrase = (typeof PRODUCTION_HANDOFF_INTRO_PHRASES)[number];

export const DEFAULT_PRODUCTION_HANDOFF_INTRO_PHRASE: ProductionHandoffIntroPhrase =
  PRODUCTION_HANDOFF_INTRO_PHRASES[0];
